import { useIntl } from 'react-intl';
import { IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { Button, SvgIcon, Tooltip } from '@rossum/ui/material';

type UpdateButtonProps = {
  isUpToDate: boolean;
  updateValue: () => void;
  disabled: boolean;
  needsInitialCalculation?: boolean;
};

export const UpdateButton = ({
  isUpToDate,
  updateValue,
  disabled,
  needsInitialCalculation,
}: UpdateButtonProps) => {
  const intl = useIntl();

  const buttonLabel = intl.formatMessage({
    id: needsInitialCalculation
      ? 'features.queueSettings.fields.formulaPreview.calculatePreview'
      : 'features.queueSettings.fields.formulaPreview.updateValues',
  });

  return isUpToDate ? (
    <Button
      variant="outlined"
      color="secondary"
      onClick={updateValue}
      disabled={disabled}
    >
      {buttonLabel}
    </Button>
  ) : (
    <Tooltip
      title={
        disabled
          ? intl.formatMessage({
              id: 'features.formulas.formulaFieldSection.noSchemaId',
            })
          : intl.formatMessage({
              id: 'features.queueSettings.fields.formulaPreview.outdated',
            })
      }
    >
      <span>
        <Button
          variant="outlined"
          color={needsInitialCalculation ? 'secondary' : 'warning'}
          disabled={disabled}
          startIcon={
            needsInitialCalculation ? undefined : (
              <SvgIcon fontSize="large">
                <IconAlertTriangle />
              </SvgIcon>
            )
          }
          onClick={updateValue}
        >
          {buttonLabel}
        </Button>
      </span>
    </Tooltip>
  );
};
